var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSheet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 0.75H3.375C2.55 0.75 1.875 1.425 1.875 2.25V12C1.875 12.4125 2.2125 12.75 2.625 12.75C3.0375 12.75 3.375 12.4125 3.375 12V3C3.375 2.5875 3.7125 2.25 4.125 2.25H11.625C12.0375 2.25 12.375 1.9125 12.375 1.5C12.375 1.0875 12.0375 0.75 11.625 0.75ZM12.0675 4.1925L15.69 7.815C15.9675 8.0925 16.125 8.475 16.125 8.8725V15.75C16.125 16.575 15.45 17.25 14.625 17.25H6.3675C5.5425 17.25 4.875 16.575 4.875 15.75L4.8825 5.25C4.8825 4.425 5.55 3.75 6.375 3.75H11.0025C11.4 3.75 11.7825 3.9075 12.0675 4.1925ZM11.625 9H15L10.875 4.875V8.25C10.875 8.6625 11.2125 9 11.625 9Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/sheet.ce5173803c7a302ae45f321023b7c9e3.svg";
export { ForwardRef as ReactComponent };